import { SvgIcon } from "@mui/material"

const PurchaseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
      <path
        d="M10.005 3.2578L18.0957 9.47397V20.113H1.91436V9.47397L10.005 3.2578ZM10.005 0.839844L0 8.53701V22.0373H20V8.53701L10.005 0.839844Z"
        fill="inherit"
      />
      <mask id="mask0_348_1014" maskUnits="userSpaceOnUse" x="1" y="5" width="17" height="16">
        <rect x="1.97656" y="5.67554" width="15.055" height="15.3152" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_348_1014)">
        <path
          d="M12.7355 18.8806L8.94042 14.988C8.73133 15.0731 8.51972 15.1369 8.30561 15.1795C8.09107 15.222 7.86357 15.2433 7.62311 15.2433C6.57763 15.2433 5.68897 14.871 4.95713 14.1265C4.22529 13.3821 3.85938 12.478 3.85938 11.4145C3.85938 11.0316 3.91165 10.6672 4.0162 10.3214C4.12075 9.97592 4.26711 9.64899 4.4553 9.34056L6.74491 11.6697L7.87403 10.5211L5.58442 8.19192C5.88761 8.00048 6.20899 7.85158 6.54857 7.74523C6.88856 7.63887 7.24674 7.58569 7.62311 7.58569C8.6686 7.58569 9.55726 7.95794 10.2891 8.70242C11.0209 9.44691 11.3869 10.3509 11.3869 11.4145C11.3869 11.6591 11.3659 11.8903 11.3241 12.1081C11.2823 12.3264 11.2196 12.5419 11.1359 12.7546L14.9624 16.6153C15.0879 16.7429 15.1506 16.8971 15.1506 17.0779C15.1506 17.2587 15.0879 17.4129 14.9624 17.5406L13.6451 18.8806C13.5196 19.0083 13.368 19.0721 13.1903 19.0721C13.0126 19.0721 12.861 19.0083 12.7355 18.8806Z"
          fill="inherit"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_348_1014" x1="20" y1="11.6016" x2="1.5785e-07" y2="11.6016" gradientUnits="userSpaceOnUse">
          <stop stopColor="#58CA04" />
          <stop offset="1" stopColor="#8DDB53" />
        </linearGradient>
        <linearGradient id="paint1_linear_348_1014" x1="15.1506" y1="13.4172" x2="3.85938" y2="13.4172" gradientUnits="userSpaceOnUse">
          <stop stopColor="#58CA04" />
          <stop offset="1" stopColor="#8DDB53" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PurchaseIcon
